module.exports = "/images/role-founder-ceo-icon.svg?d58a183e7013a14f117f4af88c539441";